import { createSlice } from '@reduxjs/toolkit'
import { getSetting } from '@/utils/settings'
const KEY_LOCAL_SETTINGS = 'OpXMOM.identity.localsettings'
const localSettingstr = localStorage.getItem(KEY_LOCAL_SETTINGS)
const defaultSettings = {
  colorWeek: getSetting('colorWeek'),
  navbar: getSetting('navbar'),
  menu: getSetting('menu'),
  footer: getSetting('footer'),
  themeColor: getSetting('themeColor'),
  menuWidth: getSetting('menuWidth'),
  popUpMenu: getSetting('popUpMenu'),
  popUpMenuType: getSetting('popUpMenuType'),
  tableHeightControl: getSetting('tableHeightControl'),
  formShowTab: getSetting('formShowTab'),
  tableSize: getSetting('tableSize'),
}
const settings = localSettingstr ? JSON.parse(localSettingstr) : defaultSettings
const appSlice = createSlice({
  name: 'app',
  initialState: {
    initialized: false,
    menuCollapse: false,
    settings: settings,
    userInfo: {
      permissions: {},
    },
    userLoading: false,
    clientHeight: 0,
    clientWidth: 0,
    isIniting: false,
    cacheRoute: [
      {
        cacheKey: 'dashboard/workplace',
        name: '工作台',
        nameEn: 'Workplace',
        path: '/dashboard/workplace',
      },
    ],
    anchorPoint: [],
    event: {},
  },
  reducers: {
    addAnchorPoint(state, action) {
      if (!action.payload) return
      const items = action.payload
      if (items.length == 0) return
      const newanchorPoint = state.anchorPoint.filter(
        (c) => c.group != items[0].group
      )
      items.forEach((item) => {
        newanchorPoint.push(item)
      })
      state.anchorPoint = newanchorPoint
    },
    removeAnchorPoint(state, action) {
      if (!action.payload) return
      const group = action.payload
      const newanchorPoint = state.anchorPoint.filter((c) => c.name != group)
      state.anchorPoint = newanchorPoint
    },
    setAnchorPoint(state, action) {
      state.anchorPoint = action.payload
    },
    setMenuCollapse(state, action) {
      state.menuCollapse = action.payload
    },
    updateSettings(state, action) {
      state.settings = action.payload
      localStorage.setItem(KEY_LOCAL_SETTINGS, JSON.stringify(action.payload))
    },
    updateUserInfo(state, action) {
      state.userInfo = action.payload
    },
    setClientHeight(state, action) {
      state.clientHeight = action.payload
    },
    setClientWidth(state, action) {
      state.clientWidth = action.payload
    },
    setIsIniting(state, action) {
      state.isIniting = action.payload
    },
    setInitialized(state, action) {
      state.initialized = action.payload
    },
    addCacheRoute(state, action) {
      const newRoute = action.payload
      const idx = state.cacheRoute.findIndex(
        (c) => c.cacheKey === newRoute.cacheKey
      )
      if (idx < 0) {
        const newCacheRoute = [...state.cacheRoute, newRoute]
        state.cacheRoute = newCacheRoute
      }
    },
    removeCacheRoute(state, action) {
      const newRoute = action.payload
      const idx = state.cacheRoute.findIndex(
        (c) => c.cacheKey === newRoute.cacheKey
      )
      if (idx > 0) {
        const newCacheRoute = [...state.cacheRoute]
        newCacheRoute.splice(idx, 1)
        state.cacheRoute = newCacheRoute
      }
    },
    clearCacheRoute(state, action) {
      const route = action.payload
      if (route) {
        const curRoute = state.cacheRoute.find(
          (c) => c.cacheKey === route.cacheKey
        )
        state.cacheRoute = [state.cacheRoute[0], curRoute]
      } else {
        state.cacheRoute = [state.cacheRoute[0]]
      }
    },
    trigger(state, action) {
      state.event = action.payload
    },
    clearEvent(state) {
      state.event = null
    },
  },
})

export const {
  addAnchorPoint,
  removeAnchorPoint,
  setAnchorPoint,
  setMenuCollapse,
  updateSettings,
  updateUserInfo,
  setClientHeight,
  setClientWidth,
  setIsIniting,
  setInitialized,
  addCacheRoute,
  removeCacheRoute,
  clearCacheRoute,
  trigger,
  clearEvent,
} = appSlice.actions
export const getAnchorPoint = (state) => state.app.anchorPoint
export const getMenuCollapse = (state) => state.app.menuCollapse
export const getClientHeight = (state) => state.app.clientHeight
export const getClientWidth = (state) => state.app.clientWidth
export const getInitialized = (state) => state.app.initialized
export const getCacheRoute = (state) => state.app.cacheRoute
export const getSettings = (state) => state.app.settings
export const getUserLoading = (state) => state.app.userLoading
export const watchEvent = (state) => state.app.event
export default appSlice.reducer
